import React from 'react';

interface AlertProps {
  children: React.ReactNode;
  variant?: 'info' | 'success' | 'warning' | 'danger';
  className?: string;
}

export const Alert = ({ 
  children, 
  variant = 'info',
  className = '' 
}: AlertProps) => {
  const variants = {
    info: "bg-blue-50 border-blue-200 text-blue-800 dark:bg-blue-900/20 dark:border-blue-800 dark:text-blue-200",
    success: "bg-accent-success/10 border-accent-success/20 text-accent-success dark:bg-accent-success/20 dark:border-accent-success/40 dark:text-accent-success",
    warning: "bg-accent-warning/10 border-accent-warning/20 text-accent-warning dark:bg-accent-warning/20 dark:border-accent-warning/40 dark:text-accent-warning",
    danger: "bg-accent-danger/10 border-accent-danger/20 text-accent-danger dark:bg-accent-danger/20 dark:border-accent-danger/40 dark:text-accent-danger",
  };

  return (
    <div 
      role={variant === 'danger' ? 'alert' : 'status'}
      aria-live={variant === 'danger' ? 'assertive' : 'polite'}
      className={`
        rounded-xl border p-4 text-sm font-medium
        ${variants[variant]} 
        ${className}
      `}
    >
      {children}
    </div>
  );
};
